"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useInterval = function useInterval(callback, delay) {
  var savedCallback = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]);
  (0, _react.useEffect)(function () {
    var tick = function tick() {
      return savedCallback.current();
    };

    var id = setInterval(tick, delay);
    return function () {
      return clearInterval(id);
    };
  }, [delay]);
};

useInterval.defaultProps = {
  callback: function callback() {},
  delay: 0
};
useInterval.propTypes = {
  callback: _propTypes.default.func.isRequired,
  delay: _propTypes.default.number.isRequired
};
var _default = useInterval;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/hooks/useInterval.js
// module id = 383
// module chunks = 0 15 16 17 18